<template>
<div class="forma forma--1" :data-step="step">

  <div class="forma-inner">

    <div class="container">

      <transition name="bounce" mode="out-in">
        <div class="carda carda--1" v-if="step === 1" key="step-1">
          <div class="loan-calculator">
            <div class="slider-section">
              <p>How much would you like to borrow?</p>
              <div class="amount-c">
                <div class="amount-monney">£{{ Application.LoanAmount }}</div>
              </div>
              <div class="slider">
                <vue-slider ref="moneySlider" v-model="Application.LoanAmount" v-bind="sliders.moneySlider"></vue-slider>
                <div class="slider-labels">
                  <div class="slider-label slider-label-min">
                    £{{ sliders.moneySlider.min }}
                  </div>
                  <div class="slider-label slider-label-max">
                    £{{ sliders.moneySlider.max }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="lc-why">
            <div class="lc-why-item">
              <div class="lc-why-icon-c">
                <b-icon icon="check" size="is-medium"></b-icon>
                <div class="lc-why-content">
                  <strong>100% Free Quote</strong>
                  No hidden fees or charges
                </div>
              </div>
            </div>
            <div class="lc-why-item">
              <div class="lc-why-icon-c">
                <b-icon icon="check" size="is-medium"></b-icon>
                <div class="lc-why-content">
                  <strong>Choose from £100-£3500</strong>
                  Cash in as little as 10 minutes*
                </div>
              </div>
            </div>
            <div class="lc-why-item">
              <div class="lc-why-icon-c">
                <b-icon icon="check" size="is-medium"></b-icon>
                <div class="lc-why-content">
                  <strong>Simple &amp; Secure Application</strong>
                  SSL encrypted and data protected
                </div>
              </div>
            </div>
          </div>
          <div class="forma-foot">
            <div class="step-buttons-c">
              <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click="step--">
                Back
              </button>
              <button class="button is-primary is-large is-rounded" type="submit" @click.once="step = 2; applicationFields.started = true;">
                Continue
              </button>
            </div>
          </div>
        </div>

        <div class="carda carda--2" v-if="step === 2" key="step-2">
          <div class="loan-calculator">
            <div class="slider-section">
              <p>How long would you like to borrow for?</p>
              <div class="amount-c">
                <div class="amount-month">{{ Application.Term }} Month<span v-if="Application.Term > 1">s</span></div>
              </div>
              <div class="slider">
                <vue-slider ref="monthsSlider" v-model="Application.Term" v-bind="sliders.monthsSlider"></vue-slider>
                <div class="slider-labels">
                  <div class="slider-label slider-label-min">
                    {{ sliders.monthsSlider.min }} Months
                  </div>
                  <div class="slider-label slider-label-max">
                    {{ sliders.monthsSlider.max }} Months
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="forma-foot">
            <div class="step-buttons-c">
              <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click="step--">
                Back
              </button>
              <button class="button is-primary is-large is-rounded" type="submit" @click.once="step = 3">
                Continue
              </button>
            </div>
          </div>
        </div>

        <div class="carda carda--3" v-if="step === 3" key="step-3">
          <form @submit.prevent="step++" @change="step = 4">
            <label class="label">Please select your title</label>
            <b-field class="radio-btn" grouped group-multiline>
              <b-radio-button v-model="Application.Title"
                  v-for="(value, key) in applicationFields.Title" :native-value="key" v-bind:key="key"
                  type="is-success"
                  size="is-large"
                  required="true"
                  name="title">
                  <span>{{ value }}</span>
              </b-radio-button>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!Application.Title">
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>


        <div class="carda carda--4" v-if="step === 4" key="step-4">
          <form @submit.prevent="step = 5">

            <b-field label="First Name">
              <b-input v-model="Application.FirstName" pattern="(([A-Z])|([a-z])|( )){2,}" required></b-input>
            </b-field>

            <b-field label="Last Name">
              <b-input v-model="Application.LastName" pattern="(([A-Z])|([a-z])|( )|-|'){2,}" required></b-input>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>

        <div class="carda carda--5" v-if="step === 5" key="step-5">
          <form @submit.prevent="step = 6">

            <!-- <b-field label="Date of Birth">
              <b-input @blur="dateOfBirtConvert(applicationFields.dateOfBirth, $event);" v-model="applicationFields.dateOfBirth" placeholder="years" expanded type="date" required></b-input>
            </b-field> -->

            <label class="label">Date of Birth</label>

            <!-- <b-field grouped class="small-labels">
              <b-field message="Day" expanded>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"
                  autocomplete="off" placeholder="dd" maxlength="2" :has-counter="false" pattern="[0-9]{2}"
                  v-model="applicationFields.dateOfBirthDay" @blur="dateOfBirtConvert(applicationFields.dateOfBirthDay, $event);" required></b-input>
              </b-field>
              <b-field message="Month" expanded>
                <b-input
                type="text"
                oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"
                autocomplete="off" placeholder="mm" maxlength="2" :has-counter="false" pattern="[0-9]{2}"
                v-model="applicationFields.dateOfBirthMonth" @blur="dateOfBirtConvert(applicationFields.dateOfBirthMonth, $event);" required></b-input>
              </b-field>
              <b-field message="Year" expanded>
                <b-input
                type="text"
                oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"
                autocomplete="off" placeholder="yyyy" maxlength="4" :has-counter="false" pattern="[0-9]{4}"
                v-model="applicationFields.dateOfBirthYear" @blur="dateOfBirtConvert(applicationFields.dateOfBirthYear, $event);" required></b-input>
              </b-field>
            </b-field> -->

            <b-field grouped class="small-labels">
              <b-field expanded>
                <b-select
                  @blur="dateOfBirtConvert($event);"
                  v-model="applicationFields.dateOfBirthDay"
                  placeholder="dd" expanded required>
                  <option value="01">1</option>
                  <option value="02">2</option>
                  <option value="03">3</option>
                  <option value="04">4</option>
                  <option value="05">5</option>
                  <option value="06">6</option>
                  <option value="07">7</option>
                  <option value="08">8</option>
                  <option value="09">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                  <option value="25">25</option>
                  <option value="26">26</option>
                  <option value="27">27</option>
                  <option value="28">28</option>
                  <option value="29">29</option>
                  <option value="30">30</option>
                  <option value="31">31</option>
                </b-select>
              </b-field>
              <b-field expanded>
                <b-select
                  @blur="dateOfBirtConvert($event);"
                  v-model="applicationFields.dateOfBirthMonth"
                  placeholder="mm" expanded required>
                  <option value="01">Jan</option>
                  <option value="02">Feb</option>
                  <option value="03">Mar</option>
                  <option value="04">Apr</option>
                  <option value="05">May</option>
                  <option value="06">Jun</option>
                  <option value="07">Jul</option>
                  <option value="08">Aug</option>
                  <option value="09">Sep</option>
                  <option value="10">Oct</option>
                  <option value="11">Nov</option>
                  <option value="12">Dec</option>
                </b-select>
              </b-field>
              <b-field expanded>
                <b-select
                  @blur="dateOfBirtConvert($event);"
                  v-model="applicationFields.dateOfBirthYear"
                  placeholder="yyyy" expanded required>
                  <option value="2001">2001</option>
                  <option value="2000">2000</option>
                  <option value="1999">1999</option>
                  <option value="1998">1998</option>
                  <option value="1997">1997</option>
                  <option value="1996">1996</option>
                  <option value="1995">1995</option>
                  <option value="1994">1994</option>
                  <option value="1993">1993</option>
                  <option value="1992">1992</option>
                  <option value="1991">1991</option>
                  <option value="1990">1990</option>
                  <option value="1989">1989</option>
                  <option value="1988">1988</option>
                  <option value="1987">1987</option>
                  <option value="1986">1986</option>
                  <option value="1985">1985</option>
                  <option value="1984">1984</option>
                  <option value="1983">1983</option>
                  <option value="1982">1982</option>
                  <option value="1981">1981</option>
                  <option value="1980">1980</option>
                  <option value="1979">1979</option>
                  <option value="1978">1978</option>
                  <option value="1977">1977</option>
                  <option value="1976">1976</option>
                  <option value="1975">1975</option>
                  <option value="1974">1974</option>
                  <option value="1973">1973</option>
                  <option value="1972">1972</option>
                  <option value="1971">1971</option>
                  <option value="1970">1970</option>
                  <option value="1969">1969</option>
                  <option value="1968">1968</option>
                  <option value="1967">1967</option>
                  <option value="1966">1966</option>
                  <option value="1965">1965</option>
                  <option value="1964">1964</option>
                  <option value="1963">1963</option>
                  <option value="1962">1962</option>
                  <option value="1961">1961</option>
                  <option value="1960">1960</option>
                  <option value="1959">1959</option>
                  <option value="1958">1958</option>
                  <option value="1957">1957</option>
                  <option value="1956">1956</option>
                  <option value="1955">1955</option>
                  <option value="1954">1954</option>
                  <option value="1953">1953</option>
                  <option value="1952">1952</option>
                  <option value="1951">1951</option>
                  <option value="1950">1950</option>
                  <option value="1949">1949</option>
                  <option value="1948">1948</option>
                  <option value="1947">1947</option>
                  <option value="1946">1946</option>
                  <option value="1945">1945</option>
                  <option value="1944">1944</option>
                  <option value="1943">1943</option>
                  <option value="1942">1942</option>
                  <option value="1941">1941</option>
                  <option value="1940">1940</option>
                  <option value="1939">1939</option>
                  <option value="1938">1938</option>
                  <option value="1937">1937</option>
                  <option value="1936">1936</option>
                  <option value="1935">1935</option>
                  <option value="1934">1934</option>
                  <option value="1933">1933</option>
                  <option value="1932">1932</option>
                </b-select>
              </b-field>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!canContinueBday">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--6" v-if="step === 6" key="step-6">
          <form @submit.prevent="step = 7">

            <b-field label="Email Address">
              <b-input v-model="Application.Email" type="email" required></b-input>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--7" v-if="step === 7" key="step-7">
          <form @submit.prevent="step = 8">

            <b-message type="is-info" has-icon size="is-small" icon-size="is-medium">
              Phone numbers must start with 0, cannot have spaces or any special characters.
            </b-message>

            <b-field label="Mobile Phone">
              <!-- ((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6} -->
              <b-input v-model="Application.MobilePhoneNumber" type="tel" pattern="^07\d{9}$" placeholder="e.g. 07123456789" required></b-input>
            </b-field>
            <!-- Enter your mobile number if you don't have a landline.  -->

            <b-field label="Home Phone" :class="{ 'no-message' : applicationFields.noLandline }">
              <b-input v-if="!applicationFields.noLandline" v-model="Application.HomePhoneNumber" type="tel" pattern="^0\d{9,10}$" placeholder="e.g. 02123456789" required></b-input>
            </b-field>

            <div class="field">
              <b-checkbox v-model="applicationFields.noLandline">I don't have a landline.</b-checkbox>
            </div>

            <b-field label="Work Phone" message="Don't worry, we won't contact your employer.">
              <b-input v-model="Application.WorkPhoneNumber" type="tel" pattern="^0\d{9,10}$" placeholder="e.g. 02123456789" required></b-input>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>

        <!-- TODO: parse INT ! -->
        <div class="carda carda--8" v-if="step === 8" key="step-8">
          <form @submit.prevent="step = 9" @change="step++">

            <label class="label">Relationship status</label>
            <b-field class="radio-btn radio-btn--blocks">
              <b-radio-button v-model="Application.MaritalStatus"
                  v-for="(value, key) in applicationFields.MaritalStatus" :native-value="key" v-bind:key="key"
                  type="is-success"
                  size="is-large">
                  <span>{{ value }}</span>
              </b-radio-button>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!Application.MaritalStatus">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--9" v-if="step === 9" key="step-9">
          <form @submit.prevent="step = 10" @change="step++">

            <label class="label">Number of Dependents</label>
            <b-field class="radio-btn radio-btn--blocks" grouped group-multiline>
              <b-radio-button v-model.number="Application.NumberOfDependents"
                  v-for="(value, key) in applicationFields.NumberOfDependents" :native-value="parseInt(key)" v-bind:key="key"
                  type="is-success"
                  size="is-large">
                  <span>{{ value }}</span>
              </b-radio-button>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="Application.NumberOfDependents === undefined">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--10" v-if="step === 10" key="step-10">
          <form @submit.prevent="step = 11">

            <label class="label">Postcode</label>
            <b-field>
              <b-input v-model="Application.AddressPostcode" pattern="^([A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] 0[Aa]{2})$" required expanded></b-input>
              <button v-on:click="addressLookup(Application.AddressPostcode, $event)" :disabled="!Application.AddressPostcode" :type="postcodeIsButton" class="button is-primary">Find your address</button>
            </b-field>

            <b-field>

            </b-field>

            <div class="field" v-if="this.applicationFields.ManualAddress == 'error'">
              Error! Enter Your Address manually
            </div>

            <b-field v-if="applicationFields.AddressesAvailable.length" label="Choose your Address">
              <b-select placeholder="Choose your Address" @input="chooseAddress($event)" expanded required>
                <option v-for="(value, key) in applicationFields.AddressesAvailable" :value="key" v-bind:key="key">{{ value.line_1 }}</option>
              </b-select>
            </b-field>

            <b-field v-if="Application.HouseNumber || applicationFields.ManualAddress" label="House Number">
              <b-input v-model="Application.HouseNumber" required></b-input>
            </b-field>
            <b-field v-if="Application.AddressStreet1 || applicationFields.ManualAddress" label="Street">
              <b-input v-model="Application.AddressStreet1" required></b-input>
            </b-field>
            <b-field v-if="Application.AddressCity || applicationFields.ManualAddress" label="Town">
              <b-input v-model="Application.AddressCity" required></b-input>
            </b-field>
            <b-field v-if="Application.AddressCounty || applicationFields.ManualAddress" label="County">
              <b-input v-model="Application.AddressCounty" required></b-input>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!(Application.HouseNumber && Application.AddressStreet1 && Application.AddressCity && Application.AddressCounty)">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--11" v-if="step === 11" key="step-11">
          <form @submit.prevent="step = 12" @change="step++">

            <label class="label">Residential Status</label>
            <b-field class="radio-btn radio-btn--blocks" grouped group-multiline>
              <b-radio-button v-model="Application.ResidentialStatus"
                  native-value="1"
                  type="is-success"
                  size="is-large">
                  <span>Home Owner</span>
              </b-radio-button>
              <b-radio-button v-model="Application.ResidentialStatus"
                  native-value="2"
                  type="is-success"
                  size="is-large">
                  <span>Private Tenant</span>
              </b-radio-button>
              <b-radio-button v-model="Application.ResidentialStatus"
                  native-value="3"
                  type="is-success"
                  size="is-large">
                  <span>Council Tenant</span>
              </b-radio-button>
              <b-radio-button v-model="Application.ResidentialStatus"
                  native-value="4"
                  type="is-success"
                  size="is-large">
                  <span>With Parents</span>
              </b-radio-button>
              <b-radio-button v-model="Application.ResidentialStatus"
                  native-value="5"
                  type="is-success"
                  size="is-large">
                  <span>Other</span>
              </b-radio-button>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!Application.ResidentialStatus">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--12" v-if="step === 12" key="step-12">
          <form @submit.prevent="step = 13">

            <div class="field">
              <label class="label">Time at Address</label>
              <b-field>
                <b-select @blur="addressTime(applicationFields.timeAtAddressYears, applicationFields.timeAtAddressMonths)"
                  v-model="applicationFields.timeAtAddressYears"
                  placeholder="years" expanded required>
                  <option value="0">0 years</option>
                  <option value="1">1 year</option>
                  <option value="2">2 years</option>
                  <option value="3">3 years</option>
                  <option value="4">4 years</option>
                  <option value="5">5 years</option>
                  <option value="6">6 years</option>
                  <option value="7">7 years</option>
                  <option value="8">8 years</option>
                  <option value="9">9 years</option>
                  <option value="10">10+ years</option>
                </b-select>
                <b-select @blur="addressTime(applicationFields.timeAtAddressYears, applicationFields.timeAtAddressMonths)"
                  v-if="applicationFields.timeAtAddressYears !== 10"
                  v-model="applicationFields.timeAtAddressMonths"
                  placeholder="months" expanded required>
                  <option value="0">0 months</option>
                  <option value="1">1 month</option>
                  <option value="2">2 months</option>
                  <option value="3">3 months</option>
                  <option value="4">4 months</option>
                  <option value="5">5 months</option>
                  <option value="6">6 months</option>
                  <option value="7">7 months</option>
                  <option value="8">8 months</option>
                  <option value="9">9 months</option>
                  <option value="10">10 months</option>
                  <option value="11">11 months</option>
                </b-select>
              </b-field>
            </div>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!(applicationFields.timeAtAddressYears && applicationFields.timeAtAddressMonths)">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--13" v-if="step === 13" key="step-13">
          <form @submit.prevent="step = 17">

            <b-field label="Income Source">
              <b-select placeholder="Select" v-model.number="Application.IncomeSource" expanded required>
                <!-- <option value="0" disabled="disabled" selected="">Select</option> -->
                <option v-for="(value, key) in applicationFields.IncomeSource" :value="key" v-bind:key="key">{{ value }}</option>
              </b-select>
            </b-field>

            <b-field label="Select the Industry Type" v-if="Application.IncomeSource && Application.IncomeSource <= 4">
              <b-select placeholder="Select" v-model.number="Application.EmployerIndustry" expanded required>
                <option v-for="(value, key) in applicationFields.EmployerIndustry" :value="key" v-bind:key="key">{{ value }}</option>
              </b-select>
            </b-field>

            <b-field label="Employer Name" v-if="Application.IncomeSource && Application.IncomeSource <= 4">
              <b-input v-model="Application.EmployerName" required pattern=".{2,}"></b-input>
            </b-field>

            <div class="field" v-if="Application.IncomeSource">
              <label class="label" v-if="Application.IncomeSource <= 4">Time at Employer</label>
              <label class="label" v-else>Time since last employment</label>
              <b-field>
                <b-select @blur="employedTime(applicationFields.timeEmployedYears, applicationFields.timeEmployedMonths)"
                 v-model="applicationFields.timeEmployedYears" placeholder="years" expanded required>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10+</option>
                </b-select>
                <b-select @blur="employedTime(applicationFields.timeEmployedYears, applicationFields.timeEmployedMonths)"
                 v-model="applicationFields.timeEmployedMonths" placeholder="months" expanded required>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                </b-select>
              </b-field>
            </div>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!Application.IncomeSource">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>

        <!-- <div class="carda carda--14" v-if="step === 14" key="step-14">
          <form @submit.prevent="step++">

            <b-field label="Employer Industry">
              <b-select placeholder="Select" v-model.number="Application.EmployerIndustry" expanded required>
                <option v-for="(value, key) in applicationFields.EmployerIndustry" :value="key" v-bind:key="key">{{ value }}</option>
              </b-select>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div> -->


        <!-- <div class="carda carda--15" v-if="step === 15" key="step-15">
          <form @submit.prevent="step++">

            <b-field label="Employer Name">
              <b-input v-model="Application.EmployerName" required pattern=".{2,}"></b-input>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div> -->


        <!-- <div class="carda carda--16" v-if="step === 16" key="step-16">
          <form @submit.prevent="step++">

            <div class="field">
              <label class="label">Time at Employer</label>
              <b-field>
                <b-select @blur="employedTime(applicationFields.timeEmployedYears, applicationFields.timeEmployedMonths)"
                 v-model="applicationFields.timeEmployedYears" placeholder="years" expanded required>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10+</option>
                </b-select>
                <b-select @blur="employedTime(applicationFields.timeEmployedYears, applicationFields.timeEmployedMonths)"
                 v-model="applicationFields.timeEmployedMonths" placeholder="months" expanded required>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                </b-select>
              </b-field>
            </div>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" @click.prevent="step-=3">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div> -->


        <div class="carda carda--17" v-if="step === 17" key="step-17">
          <form @submit.prevent="step = 18">

            <b-field label="Pay Frequency">
              <b-select placeholder="Select" v-model.number="Application.PayFrequency" expanded required>
                <option value="1">Weekly</option>
                <option value="2">Bi-weekly</option>
                <option value="3">Fortnightly</option>
                <option value="4">Last day of month</option>
                <option value="5">Last working day of month</option>
                <option value="6">Specific date</option>
                <option value="7">Twice monthly</option>
                <option value="8">Four weekly</option>
                <option value="9">Last friday of month</option>
                <!-- <option value="13">Last Monday of month</option> -->
                <!-- <option value="12">Last Tuesday of month</option> -->
                <!-- <option value="11">Last Wednesday of month</option> -->
                <!-- <option value="10">Last Thursday of month</option> -->
              </b-select>
            </b-field>

            <b-field
              v-if="Application.PayFrequency == 1 || Application.PayFrequency == 2 || Application.PayFrequency == 3 || Application.PayFrequency == 6 || Application.PayFrequency == 7 || Application.PayFrequency == 8"
              label="Next Pay Date" :message="errors.nextPayErr">
              <b-input @blur="nextPayDate(applicationFields.NextPay, 0)"
                 v-model="applicationFields.NextPay" type="date" :min="new Date().toISOString().split('T')[0]" required></b-input>
            </b-field>

            <b-field
              v-if="Application.PayFrequency == 1 || Application.PayFrequency == 2 || Application.PayFrequency == 3 || Application.PayFrequency == 6 || Application.PayFrequency == 7 || Application.PayFrequency == 8"
              label="Following Pay Date" :message="errors.followingPayErr">
              <b-input @blur="nextPayDate(applicationFields.FollowingPay, 1)"
                 v-model="applicationFields.FollowingPay" type="date" required></b-input>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step-=4">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit" :disabled="!(Application.PayFrequency && Application.NextPayDate && Application.FollowingPayDate)">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>

        <div class="carda carda--18" v-if="step === 18" key="step-18">
          <form @submit.prevent="step = 19">

            <b-field label="Payment Type">
              <b-select placeholder="Select" v-model.number="Application.IncomePaymentType" expanded required>
                <option value="4">Direct Deposit (UK Bank)</option>
                <option value="5">Direct Deposit (Other country)</option>
                <option value="2">Cheque</option>
                <option value="3">Cash</option>
              </b-select>
            </b-field>

            <b-field label="Net MONTHLY Pay Amount">
              <b-select placeholder="Select" v-model.number="Application.PayAmount" expanded required>
                <option value="250">£500 or less</option>
                <option value="675">£501 - £750</option>
                <option value="900">£751 - £1,000</option>
                <option value="1150">£1,001 - £1,250</option>
                <option value="1400">£1,251 - £1,500</option>
                <option value="1700">£1,501 - £1,750</option>
                <option value="1875">£1,751 - £2,000</option>
                <option value="2175">£2,001 - £2,250</option>
                <option value="2375">£2,251 - £2,500</option>
                <option value="2675">£2,501 - £2,750</option>
                <option value="2875">£2,751 - £3,000</option>
                <option value="3125">£3,001 - £3,250</option>
                <option value="3375">£3,251 - £3,500</option>
                <option value="3675">£3,501 - £3,750</option>
                <option value="3875">£3,751 - £4,000</option>
                <option value="4125">£4,001 - £4,250</option>
                <option value="4375">£4,251 - £4,500</option>
                <option value="4675">£4,501 - £4,750</option>
                <option value="4875">£4,751 - £5,000</option>
                <option value="5000">£5,000 +</option>
              </b-select>
            </b-field>

            <template v-if="Application.MaritalStatus == 2" class="field">
               <b-field label="Combined Monthly Household Income">
                 <b-select placeholder="Select" v-model.number="Application.CombinedMonthlyHouseholdIncome" expanded required>
                   <option selected="selected" disabled="disabled" value="">Select</option>
                   <option value="800">£1,000 or less</option>
                   <option value="1700">£1,001 - £2,000</option>
                   <option value="2700">£2,001 - £3,000</option>
                   <option value="3700">£3,001 - £4,000</option>
                   <option value="4700">£4,001 - £5,500</option>
                   <option value="5700">£5,001 - £6,000</option>
                   <option value="6700">£6,001 - £7,000</option>
                   <option value="7700">£7,001 - £8,000</option>
                   <option value="8200">£8,000 +</option>
                 </b-select>
             </b-field>
            </template>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--19" v-if="step === 19" key="step-19">
          <form @submit.prevent="step = 20">

            <b-field label="Mortgage / Rent" message="* Include your monthly mortgage payments or the monthly rent">
              <b-select placeholder="Select" v-model.number="Application.MonthlyMortgageRent" expanded required>
                <option value="0">£0.00</option>
                <option value="250">£1 - £500</option>
                <option value="750">£501 - £1000</option>
                <option value="1250">£1001 - £1500</option>
                <option value="1750">£1501 - £2000+</option>
              </b-select>
            </b-field>

            <b-field label="Monthly Credit Commitments" message="* Include all your monthly credit commitments excluding your mortgage">
              <b-select placeholder="Select" v-model.number="Application.MonthlyCreditCommitments" expanded required>
                <option value="0">£0.00</option>
                <option value="75">£51 - £100</option>
                <option value="150">£101 - £200</option>
                <option value="250">£201 - £300</option>
                <option value="350">£301 - £400</option>
                <option value="450">£401 - £500</option>
                <option value="600">£501 - £700</option>
                <option value="850">£701 - £1000</option>
                <option value="1000">£1001+</option>
              </b-select>
            </b-field>

            <b-field label="Utilities" message="* e.g. heating, electricity, gas, telephone">
              <b-select placeholder="Select" v-model.number="Application.Utilities" expanded required>
                <option value="0">£0.00</option>
                <option value="75">£51 - £100</option>
                <option value="150">£101 - £200</option>
                <option value="250">£201 - £300</option>
                <option value="350">£301 - £400</option>
                <option value="450">£401 - £500</option>
                <option value="600">£501 - £700</option>
                <option value="850">£701 - £1000</option>
                <option value="1000">£1001+</option>
              </b-select>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--20" v-if="step === 20" key="step-20">
          <form @submit.prevent="step = 21">

            <b-field label="Food" message="* your monthly food costs">
              <b-select placeholder="Select" v-model.number="Application.Food" expanded required>
                <option value="25">£0 - £50</option>
                <option value="75">£51 - £100</option>
                <option value="125">£101 - £150</option>
                <option value="175">£151 - £200</option>
                <option value="225">£201 +</option>
              </b-select>
            </b-field>

            <b-field label="Transport" message="* e.g. Petrol, rail cost">
              <b-select placeholder="Select" v-model.number="Application.Transport" expanded required>
                <option value="25">£0 - £50</option>
                <option value="75">£51 - £100</option>
                <option value="125">£101 - £150</option>
                <option value="175">£151 - £200</option>
                <option value="225">£201 - £250</option>
                <option value="275">£251 - £300</option>
                <option value="325">£301 - £350</option>
                <option value="375">£351 - £400</option>
                <option value="425">£401 - £450</option>
                <option value="475">£451 - £500</option>
                <option value="525">£501 +</option>
              </b-select>
            </b-field>

            <b-field label="Other regular expenses" message="* Include your monthly regular bills for example: Council Tax, Mobile, Childcare">
              <b-select placeholder="Select" v-model.number="Application.OtherExpenses" expanded required>
                <option value="0">£0.00</option>
                <option value="75">£51 - £100</option>
                <option value="150">£101 - £200</option>
                <option value="250">£201 - £300</option>
                <option value="350">£301 - £400</option>
                <option value="450">£401 - £500</option>
                <option value="600">£501 - £700</option>
                <option value="850">£701 - £1000</option>
                <option value="1000">£1001+</option>
              </b-select>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--21" v-if="step === 21" key="step-21">
          <form @submit.prevent="step = 22">

            <b-field label="Account Number" message="*Your 8-digit bank account number. This is not your card number.">
              <b-input v-model="Application.BankAccountNumber" oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');" required pattern="^(?!(?:0{8}))([0-9]{8})$" placeholder="00000000"></b-input>
            </b-field>

            <b-field label="Sort Code">
              <b-input v-model="applicationFields.BankRoutingNumber" required pattern="^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$" placeholder="00-00-00"></b-input>
            </b-field>

            <b-field label="Primary Debit Card held">
              <b-select placeholder="Select" v-model.number="Application.BankCardType" expanded required>
                <option value="2">Solo</option>
                <option value="3">Switch/Maestro</option>
                <option value="4">Visa</option>
                <option value="5">Visa Debit</option>
                <option value="6">Visa Delta</option>
                <option value="7">Visa Electron</option>
                <option value="9">MasterCard</option>
                <option value="10">MasterCard Debit</option>
              </b-select>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--22" v-if="step === 22" key="step-22">
          <form @submit.prevent="step = 23">

            <b-field label="Purpose of Loan">
              <b-select v-model.number="Application.LoanProceedUse"
                placeholder="Select" expanded required>
                <option value="Unknown" disabled="disabled" selected="">Select</option>
                <option value="1">Subsistence</option>
                <option value="2">OneOffPurchase</option>
                <option value="4">Debt Consolidation</option>
                <option value="5">Car Loan</option>
                <option value="6">Pay Bills</option>
                <option value="7">Pay Off Loan</option>
                <option value="8">Short Term Cash</option>
                <option value="9">Home Improvements</option>
                <option value="3">Other</option>
              </b-select>
            </b-field>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-large is-rounded" type="button" @click.prevent="step--">
                  Back
                </button>
                <button class="button is-primary is-large is-rounded" type="submit">
                  Continue
                </button>
              </div>
            </div>

          </form>
        </div>


        <div class="carda carda--23" v-if="step === 23" key="step-23">
            <div class="form-terms has-text-left content">

              <p>
                By submitting this application, I confirm that I have read, understood and agree to Nouveau Finance’s <router-link to="/terms-conditions" target="_blank">Terms &amp; Conditions</router-link> and <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>.
                I understand a credit check may be carried out in relation to my application
              </p>
              <p>
                <strong>To receive more great deals from Nouveau Finance:</strong>
              </p>
              <p>* I am happy for Nouveau Finance and their trusted 3rd party partners <a class="partner-list-link" style="display:none;">listed here</a> to send me information about products, services and offers that might be of interest to me as listed in the Privacy Policy via <strong>(tick below)</strong>:</p>

              <div class="field checkbox-field">
                <b-checkbox v-model="Application.ConsentToMarketingSms">SMS</b-checkbox>
              </div>

              <div class="field checkbox-field">
                <b-checkbox v-model="Application.ConsentToMarketingEmails">Email</b-checkbox>
              </div>

              <div class="field checkbox-field">
                <b-checkbox v-model="Application.ConsentToMarketingPhone">Phone</b-checkbox>
              </div>

              <p class="small">
                <strong>Note:</strong>
                You can opt-out of these messages at any time.
                For more details please see our <router-link to="/privacy-policy" target="_blank" class="consent-link ui-link">Privacy Policy</router-link> which also explains the types of companies who may contact you and the way they will use the information you have provided.
                All parties will use your data in accordance with the Data Protection Act 2018 and other applicable law relating to privacy including the General Data Protection Regulation 2016.
              </p>

            </div>

            <div class="forma-foot">
              <div class="step-buttons-c">
                <button v-if="step !== 1" class="button is-link is-small is-rounded" type="button" @click="step--">
                  Back
                </button>
                <button class="button is-success is-large is-rounded" type="submit" @click.once="applyForLoan">
                  Get Quote
                </button>
              </div>
            </div>

        </div>

      </transition>

      <div v-if="waiting" class="loading-container">
        <div class="loading-container-inner">
          <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          <progress class="progress is-success" :value="submitProgress" max="100">{{submitProgress}}%</progress>
          <p>{{submitProgress}}%</p>
          <div class="waiting-text" v-if="waitingText"><div class="waiting-text-inner" v-html="waitingText"></div></div>
        </div>
      </div>

    </div>

  </div>


</div>
</template>

<script>

import vueSlider from 'vue-slider-component';
import axios from 'axios';
import store from '../store';

export default {
  name: 'home',
  components: {
    vueSlider,
  },
  data() {
    return {
      submitProgress: 5,
      storeState: store.state,
      step: 1,
      stepsTotal: 4,
      isNextModalActive: false,
      isCardModalActive: false,
      result: false,
      sliders: {
        moneySlider: {
          value: 400,
          min: 100,
          max: 3500,
          interval: 50,
          tooltip: false,
          dotSize: 32,
          processStyle: {
            backgroundColor: '#99d55a',
          },
          bgStyle: {
            backgroundColor: '#eeeeee',
          },
        },
        monthsSlider: {
          value: 4,
          plural: true,
          min: 2,
          max: 24,
          tooltip: false,
          dotSize: 32,
          processStyle: {
            backgroundColor: '#99d55a',
          },
          bgStyle: {
            backgroundColor: '#eeeeee',
          },
        },
      },
      RequestJSON: {
        Campaign: 'TEST',
        AffiliateId: 'RISE-UK1',
        // Timeout: 100,
        // SubAffiliate: null,
        TestOnly: false,
        SourceDetails: {
          Address: undefined,
          ClientUserAgent: navigator.userAgent,
          CreationUrl: 'http://speedyloans.co.uk',
          ReferringUrl: 'http://speedyloans.co.uk',
        },
      },
      Application: {
        AddressCity: '',
        AddressCounty: '',
        AddressMoveIn: '',
        AddressPostcode: '',
        AddressStreet1: '',
        BankAccountNumber: '',
        BankCardType: undefined,
        UsesOnlineBanking: true,
        BankRoutingNumber: '',
        ConsentToCreditSearch: true,
        ConsentToMarketingEmails: false,
        ConsentToMarketingSms: false,
        ConsentToMarketingPhone: false,
        DateOfBirth: '',
        IncomePaymentType: undefined,
        Email: '',
        EmployerIndustry: undefined,
        // EmployerName: 'unemployed',
        EmployerName: '',
        EmploymentStarted: '',
        FirstName: '',
        HouseNumber: '',
        FollowingPayDate: '',
        HomePhoneNumber: '',
        HouseName: '',
        IncomeSource: undefined,
        JobTitle: '',
        LastName: '',
        LoanAmount: 400,
        MobilePhoneNumber: '',
        NextPayDate: '',
        PayAmount: undefined,
        PayFrequency: 0,
        ResidentialStatus: 0,
        Term: 6,
        Title: 0,
        WorkPhoneNumber: '',
        MonthlyMortgageRent: undefined,
        MonthlyCreditCommitments: undefined,
        OtherExpenses: undefined,
        Transport: undefined,
        Food: undefined,
        Utilities: undefined,
        ConfirmedByApplicant: true,
        MaritalStatus: 0,
        LoanProceedUse: 0,
        NumberOfDependents: undefined,
        CombinedMonthlyHouseholdIncome: 0,
        ApplicationExtensions: [
          {
            Name: 'speedy_ver',
            Value: '1.18',
          },
        ],
      },
      applicationFields: {
        started: false,
        Title: {
          1: 'Mr',
          2: 'Mrs',
          3: 'Ms',
          4: 'Miss',
        },
        MaritalStatus: {
          1: 'Single',
          2: 'Married',
          3: 'Living Together',
          4: 'Separated',
          5: 'Divorced',
          6: 'Widowed',
          7: 'Other',
        },
        NumberOfDependents: {
          0: 'None',
          1: 1,
          2: 2,
          3: 3,
          4: 4,
          5: '5+',
        },
        AddressesAvailable: [],
        ManualAddress: false,
        IncomeSource: {
          1: 'Self Employed',
          2: 'Employed Full Time',
          3: 'Employed Part Time',
          4: 'Employed Temporary',
          5: 'Pension',
          6: 'Disability Benefits',
          7: 'Benefits',
        },
        EmployerIndustry: {
          1: 'Construction\\Manufacturing',
          2: 'Military',
          3: 'Health',
          4: 'Banking\\Insurance',
          5: 'Education',
          6: 'Civil Service',
          7: 'Supermarket\\Retail',
          8: 'Utilities\\Telecom',
          9: 'Hotel, Restaurant and Leisure',
          10: 'Other, Office-based',
          11: 'Other, not Office-based',
          12: 'None',
          13: 'Driving\\Delivery',
          14: 'Administration\\Secretarial',
          15: 'Mid Level Management',
          16: 'Senior Level Management',
          17: 'Skilled Trade',
          18: 'Professional',
        },
        timeAtAddressYears: undefined,
        timeAtAddressMonths: undefined,
        timeEmployedYears: undefined,
        timeEmployedMonths: undefined,
        workNumber: undefined,
        homeNumber: undefined,
        mobNumber: undefined,
        NextPay: undefined,
        FollowingPay: undefined,
        dateOfBirthDay: undefined,
        dateOfBirthMonth: undefined,
        dateOfBirthYear: undefined,
        noLandline: false,
      },
      errors: {
        // messages: {
        //   phoneError: 'Must be valid Number',
        // },
      },
      badDates: {
        dates: [
          // '2019-01-01',
          // 'April 19th, 2019',
          // 'April 22nd, 2019',
          // 'May 6th, 2019',
          // 'May 27th, 2019',
          // 'August 26th, 2019',
          // 'December 25th, 2019',
          // 'December 26th, 2019',
          // 'January 1st, 2020',
          // 'April 10th, 2020',
          // April 13th, 2020,
          // May 4th, 2020,
          // May 25th, 2020,
          // August 31st, 2020,
          // December 25th, 2020,
          // December 26th, 2020,
          // December 28th, 2020,
          // January 1st, 2019,
          // April 19th, 2019,
          // April 22nd, 2019,
          // May 6th, 2019,
          // May 27th, 2019,
          // August 26th, 2019,
          // December 25th, 2019,
          // December 26th, 2019,
          // January 1st, 2020,
          // April 10th, 2020,
          // April 13th, 2020,
          // May 4th, 2020,
          // May 25th, 2020,
          // August 31st, 2020,
          // December 25th, 2020,
          // December 26th, 2020,
          // December 28th, 2020
        ],
      },
      waiting: false,
      waitingText: '',
    };
  },
  watch: {
    step(val) {
      // console.log(this.step);
      // console.log(dataLayer);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'formStep',
        stepNo: val,
        formId: 'form-1',
      });
    },
    payFreq(val) {
      // console.log('payFreq Changed! =====' + val);
      const d = new Date(); // date now
      const n = d.getMonth(); // month now
      const y = d.getFullYear(); // year now
      let payNext = false;
      if (val === 4 || val === 5) {
        // console.log('Last Day of month');
        payNext = new Date(y, n + 1, 0); // get last day of month

        // TODO: BANK HOLIDAY CHECKER
        // let i;
        // for (i = 0; i < this.badDates.dates.length; i += 1) {
        //   // console.log(this.badDates.dates[i], '<bad', date);
        //   if (date === this.badDates.dates[i]) {
        //     // console.log('badDate!');
        //     console.log('Pay Date must not be on a bank Holiday');
        //   }
        // }

        if (payNext === d) { // check if today => add 1month
          payNext.setMonth(payNext.getMonth() + 1);
        }
        if (payNext.getDay() === 0) { // if sunday -2days
          payNext.setDate(payNext.getDate() - 2);
        }
        if (payNext.getDay() === 6) { // if saturdat -1days
          payNext.setDate(payNext.getDate() - 1);
        }
      } else if (val === 9) {
        payNext = this.lastFridayOfMonth(y, n);

        if (payNext <= d) {
          payNext = this.lastFridayOfMonth(y, n + 1);
        }
      } else if (val) {
        this.Application.NextPayDate = '';
        this.Application.FollowingPayDate = '';
        this.applicationFields.FollowingPay = undefined;
        this.applicationFields.NextPay = undefined;
      }

      if (payNext) {
        // console.log('adiuhashduiasdiuasui');
        let dd = payNext.getDate();
        let mm = payNext.getMonth() + 1; // January is 0!

        const yyyy = payNext.getFullYear();
        if (dd < 10) {
          // dd = '0' + dd;
          dd = `0${dd}`;
        }
        if (mm < 10) {
          // mm = '0' + mm;
          mm = `0${mm}`;
        }
        // let payNextFormatted = dd + '/' + mm + '/' + yyyy;
        const payNextFormatted2 = `${yyyy}-${mm}-${dd}`; // yyyy + '-' + mm + '-' + dd;

        this.applicationFields.NextPay = payNextFormatted2;

        this.nextPayDate(payNextFormatted2, 0);
      }
    },
  },
  computed: {
    postcodeIsButton() {
      let buttonType = 'submit';
      if (this.applicationFields.AddressesAvailable.length) {
        buttonType = 'button';
      }
      return buttonType;
    },
    progressBar() {
      return this.step / this.stepsTotal * 100;
    },
    payFreq() {
      return this.Application.PayFrequency;
    },
    canContinueBday() {
      let canContinue = false;
      if (this.applicationFields.dateOfBirthDay && this.applicationFields.dateOfBirthMonth && this.applicationFields.dateOfBirthYear) {
        if (this.applicationFields.dateOfBirthDay.length === 2 && this.applicationFields.dateOfBirthMonth.length === 2 && this.applicationFields.dateOfBirthYear.length === 4) {
          canContinue = true;
        }
      }
      return canContinue;
    },
  },
  mounted() {
    // Add ApplicationExtensions from query string
    // if (this.$route.query.gclid) {
    //   // this.Application.ApplicationExtensions.push({ gclid: this.$route.query.gclid });
    //   this.Application.ApplicationExtensions.push({
    //     Name: 'gclid',
    //     Value: this.$route.query.gclid,
    //   });
    // }
    if (this.storeState.gclid) {
      this.Application.ApplicationExtensions.push({
        Name: 'gclid',
        Value: this.storeState.gclid,
      });
    }
    if (this.storeState.la) {
      this.Application.LoanAmount = this.storeState.la;
    }

    if (this.storeState.campaign) {
      this.RequestJSON.Campaign = this.storeState.campaign;
    }

    // Get user IP and store in SourceDetails
    axios.get('https://api.ipify.org')
      .then((response) => {
        console.log(response.data);
        this.RequestJSON.SourceDetails.Address = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });

    this.RequestJSON.Application = this.Application;
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'formStep',
      stepNo: 1,
      formId: 'form-1',
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.changed() && !confirm('You sure you want to go back to the homepage? Changes that you made will be lost.')) next(false); // eslint-disable-line
    else next();
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.unload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.unload);
  },
  methods: {
    inFuture(date, date2) {
      return date.setHours(0, 0, 0, 0) > date2.setHours(0, 0, 0, 0);
    },
    validatePayFrequency() {
      const nextPay = this.applicationFields.NextPay;
      const followingPay = this.applicationFields.FollowingPay;
      console.log(nextPay, followingPay);

      const todayPlusFourtyFour = new Date();
      todayPlusFourtyFour.setDate(todayPlusFourtyFour.getDate() + 45);

      let errors = false;

      if (!this.inFuture(new Date(`${followingPay} 23:59:59`), new Date(`${nextPay} 23:59:59`))) {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          // text: 'Following pay date must be within 45 days of the next pay date!',
          text: 'Following pay date must be after next pay date!',
        });
        errors = true;
      }

      if (this.inFuture(new Date(`${nextPay} 00:00:01`), todayPlusFourtyFour)) {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          // text: 'Following pay date must be within 45 days of the next pay date!',
          text: 'Next pay date must be within 45 days!',
        });
        errors = true;
      }

      if (!errors) {
        this.step = 18;
      }
    },
    unload($event) {
      if (!this.changed()) return true;
      var confirmationMessage = "\o/"; // eslint-disable-line

      // Gecko, Trident, Chrome 34+
      $event.returnValue = confirmationMessage; // eslint-disable-line
      return confirmationMessage; // Gecko, WebKit, Chrome <34
    },
    changed() {
      return this.applicationFields.started;
    },
    getAge(birthDate) {
      return Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e+10);
    },
    lastFridayOfMonth(year, month) {
      let lastDay = new Date(year, month + 1, 0); // eslint-disable-line prefer-const
      if (lastDay.getDay() < 5) {
        lastDay.setDate(lastDay.getDate() - 7);
      }
      lastDay.setDate(lastDay.getDate() - (lastDay.getDay() - 5));
      return lastDay;
    },
    prev() {
      this.step--;
    },
    next() {
      this.step++;
    },
    addressLookup(postcode, event) {
      if (event) event.preventDefault();
      this.applicationFields.ManualAddress = false;
      this.applicationFields.AddressesAvailable = [];
      this.Application.HouseNumber = '';
      this.Application.AddressStreet1 = '';
      this.Application.AddressCity = '';
      this.Application.AddressCounty = '';
      axios.get(`https://api.getAddress.io/find/${postcode}?api-key=XFvWQjqVKEa_Rr-zbh4VGA17329&expand=true`)
        .then((response) => {
          this.applicationFields.AddressesAvailable = response.data.addresses;
          this.applicationFields.ManualAddress = true;
          this.Application.AddressPostcode = response.data.postcode;
        })
        .catch((error) => {
          console.log(error.response);
          this.applicationFields.ManualAddress = 'error';
        });
    },
    chooseAddress(addressId) {
      // console.log(this.applicationFields.AddressesAvailable[addressId]);
      this.Application.HouseNumber = this.applicationFields.AddressesAvailable[addressId].building_number;
      this.Application.AddressStreet1 = this.applicationFields.AddressesAvailable[addressId].thoroughfare;
      this.Application.AddressCity = this.applicationFields.AddressesAvailable[addressId].town_or_city;
      this.Application.AddressCounty = this.applicationFields.AddressesAvailable[addressId].county;

      if (!this.Application.AddressCounty && this.Application.AddressCity === 'London') {
        this.Application.AddressCounty = 'Greater London';
      }
      // console.log(this.Application.HouseNumber);
    },
    timestampFromToday(years = 0, months = 0) {
      let timestamp = Math.round(new Date().getTime() / 1000); // getTimestamp of today in Milliseconds
      timestamp -= (years * 31536000) + (months * 2628003.6); // timestamp = years* how many hours in year + hours in month
      let newTime = new Date(timestamp * 1000); // convert back to timestamp
      newTime = (Date.parse(newTime) / 1000);
      return newTime * 1000;
    },
    employedTime(years = 0, months = 0) {
      // eslint-disable-next-line
      this.Application.EmploymentStarted = `\/Date(${this.timestampFromToday(years, months)})\/`;
    },
    addressTime(years = 0, months = 0) {
      // eslint-disable-next-line
      this.Application.AddressMoveIn = `\/Date(${this.timestampFromToday(years, months)})\/`;
    },
    // dateOfBirtConvert(dateString) {
    //   console.log(dateString);
    //   let dateStamp = new Date(dateString).getTime() / 1000;
    //   dateStamp *= 1000;
    //   let eighteenYearsAgo = new Date();
    //   eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    //   console.log(`japa: ${eighteenYearsAgo}`);
    //   // day18YearsAgo.setMonth(day18YearsAgo.getMonth() – 12);
    //   // eighteenYearsAgo = eighteenYearsAgo.getTime() / 1000;
    //   console.log(dateStamp, eighteenYearsAgo);
    //   if (dateStamp < eighteenYearsAgo) { // check if age > 18
    //     // eslint-disable-next-line
    //     this.Application.DateOfBirth = `\/Date(${dateStamp})\/`;
    //   } else {
    //     console.log('Not old enough');
    //     // const dobError = "You must be at least 18+";
    //   }
    // },
    dateOfBirtConvert() {
      // console.log(dateString);
      if (this.applicationFields.dateOfBirthDay && this.applicationFields.dateOfBirthMonth && this.applicationFields.dateOfBirthYear) {
        const dateString = `${this.applicationFields.dateOfBirthYear}-${this.applicationFields.dateOfBirthMonth}-${this.applicationFields.dateOfBirthDay}`;
        let dateStamp = new Date(dateString).getTime() / 1000;
        dateStamp *= 1000;
        this.Application.DateOfBirth = `\/Date(${dateStamp})\/`; // eslint-disable-line
      }
    },
    nextPayDate(date, following = 0) {
      const todayDate = new Date().getTime() / 1000;
      let payDate = new Date(date).getTime() / 1000;
      const payDateSave = new Date(date);
      // const monthToday = payDateSave.getMonth() + 1;

      let fourtyFourFrom = new Date().getTime();
      if (following < 1) {
        // do nothing
      } else {
        fourtyFourFrom = new Date(this.applicationFields.NextPay);
      }

      const payDatePlusWeek = new Date(date);
      payDatePlusWeek.setDate(payDatePlusWeek.getDate() + 7);

      const payDatePlusHalfWeek = new Date(date);
      payDatePlusHalfWeek.setDate(payDatePlusHalfWeek.getDate() + 4);

      const payDatePlusTwoWeeks = new Date(date);
      payDatePlusTwoWeeks.setDate(payDatePlusTwoWeeks.getDate() + 14);

      const payDatePlusFourWeeks = new Date(date);
      payDatePlusFourWeeks.setDate(payDatePlusFourWeeks.getDate() + 28);

      const payDatePlusOneMonth = new Date(date);
      payDatePlusOneMonth.setMonth(payDatePlusOneMonth.getMonth() + 1);

      const todayPlusFourtyFour = new Date(fourtyFourFrom);
      todayPlusFourtyFour.setDate(todayPlusFourtyFour.getDate() + 45);

      if (payDate > todayDate) {
        this.errors.nextPayErr = '';
        this.errors.followingPayErr = '';
        // console.log('in Future', todayDate, payDate);
        let i;
        for (i = 0; i < this.badDates.dates.length; i += 1) {
          // console.log(this.badDates.dates[i], '<bad', date);
          if (date === this.badDates.dates[i]) {
            // console.log('badDate!');
            this.errors.nextPayErr = 'Pay Date must not be on a bank Holiday';
          }
        }

        // if ( (todayPlusFourtyFour.getTime() / 1000) > payDate) {
        const kurwacontinue = true;
        if (kurwacontinue) {
          this.errors.nextPayErr = '';
          this.errors.followingPayErr = '';
          // console.log('success');
          payDate *= 1000;
          if (following < 1) {
            // console.log('NextSuccess!');
            // eslint-disable-next-line
            this.Application.NextPayDate = `\/Date(${payDate})\/`;

            // let followingSet = false;
            let payFollowing = false;
            if (this.Application.PayFrequency === 4 || this.Application.PayFrequency === 5 || this.Application.PayFrequency === 6) {
              if (this.Application.PayFrequency === 6) {
                payFollowing = payDateSave;
                payFollowing.setMonth(payFollowing.getMonth() + 1);
              } else {
                const aan = payDateSave.getMonth(); // month now
                const aay = payDateSave.getFullYear(); // year now
                payFollowing = new Date(aay, aan + 2, 0); // get last day of month
              }
              if (payFollowing.getDay() === 0) { // if sunday -2days
                payFollowing.setDate(payFollowing.getDate() - 2);
              }
              if (payFollowing.getDay() === 6) { // if saturdat -1days
                payFollowing.setDate(payFollowing.getDate() - 1);
              }
            } else if (this.Application.PayFrequency === 9) {
              payFollowing = this.lastFridayOfMonth(payDateSave.getFullYear(), payDateSave.getMonth() + 1);
            } else if (this.Application.PayFrequency === 1) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 7);
            } else if (this.Application.PayFrequency === 2) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 3);

              if (payFollowing.getDay() === 0) { // if sunday -2days
                payFollowing.setDate(payFollowing.getDate() + 1);
              }
              if (payFollowing.getDay() === 6) { // if saturdat -1days
                payFollowing.setDate(payFollowing.getDate() - 1);
              }
            } else if (this.Application.PayFrequency === 3 || this.Application.PayFrequency === 7) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 14);
            } else if (this.Application.PayFrequency === 8) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 28);
            }
            if (payFollowing) {
              let dd = payFollowing.getDate();
              let mm = payFollowing.getMonth() + 1; // January is 0!

              const yyyy = payFollowing.getFullYear();
              if (dd < 10) {
                dd = `0${dd}`;
              }
              if (mm < 10) {
                mm = `0${mm}`;
              }

              const payNextFormatted2 = `${yyyy}-${mm}-${dd}`; // yyyy + '-' + mm + '-' + dd
              this.applicationFields.FollowingPay = payNextFormatted2;
              this.nextPayDate(payNextFormatted2, 1);
            }
          } else {
            // console.log('FollowSuccess!');
            // eslint-disable-next-line
            this.Application.FollowingPayDate = `\/Date(${payDate})\/`;
          }
        } else if (following < 1) {
          console.log(following);
          this.errors.followingPayErr = 'must be less than 45 days in the future';
        } else {
          this.errors.nextPayErr = 'must be less than 45 days in the future';
        }
      } else if (following < 1) {
        this.errors.followingPayErr = 'must be in the future';
      } else {
        this.errors.nextPayErr = 'must be in the future';
      }
    },
    applyForLoan() {
      if (this.applicationFields.noLandline) {
        this.Application.HomePhoneNumber = this.Application.MobilePhoneNumber;
      }
      if (this.Application.IncomeSource > 4) {
        this.Application.EmployerName = 'unemployed';
        this.Application.EmployerIndustry = 12;
      }
      // console.log(this.Application);
      this.result = this.Application;
      // this.result.HomePhoneNumber = this.Application.MobilePhoneNumber;
      this.Application.BankRoutingNumber = this.applicationFields.BankRoutingNumber;

      this.waiting = true;
      this.waitingText = 'Sending...';

      const keywordData = new FormData();
      keywordData.append('adpos', this.storeState.awAdpos);
      keywordData.append('device', this.storeState.awDevice);
      keywordData.append('keyword', this.storeState.awKeyword);
      keywordData.append('matchtype', this.storeState.awMatchtype);
      keywordData.append('gclid', this.storeState.gclid);
      keywordData.append('speedy_id', this.storeState.speedyId);
      keywordData.append('campaign', this.RequestJSON.Campaign);
      keywordData.append('utm_campaign', this.storeState.utmCampaign);
      keywordData.append('utm_content', this.storeState.utmContent);
      keywordData.append('utm_medium', this.storeState.utmMedium);
      keywordData.append('utm_source', this.storeState.utmSource);
      keywordData.append('utm_term', this.storeState.utmTerm);
      keywordData.append('speedy_ver', this.Application.ApplicationExtensions[0].Value);
      keywordData.append('ip', this.RequestJSON.SourceDetails.Address);
      keywordData.append('user_agent', this.RequestJSON.SourceDetails.ClientUserAgent);
      keywordData.append('loan_amount', this.Application.LoanAmount);
      keywordData.append('loan_term', this.Application.Term);

      // console.log(keywordData);

      // send POST date
      const axiosConfig = {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          // 'App-Test-Response-Type': 'LenderMatchFound',
        },
      };

      axios.post('https://leads.pingyo.co.uk/application/submit', JSON.stringify(this.RequestJSON), axiosConfig)
        .then((response) => {
          // console.log(response);
          this.waitingText = 'Thanks for requesting your loan - your loan application is BEING PROCESSED...';
          if (response.status === 202) {
            setTimeout(() => {
              const correlationId = response.data.CorrelationId;
              this.checkApplicationProgress(correlationId);
            }, 5000);
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.loanResultFail();
        });

      axios.post('https://s2s.speedyloans.co.uk/pixel/keyword_data.php', keywordData)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error.response);
        });

      // axios.post('https://s2s.speedyloans.co.uk/pixel/get_results.php?action=look', JSON.stringify(this.RequestJSON), axiosConfig);
    },
    checkApplicationProgress(correlationId) {
      axios.get(`https://leads.pingyo.co.uk/application/status/${correlationId}`)
        .then((response) => {
          const progress = response.data.PercentageComplete;
          this.submitProgress = progress;

          if (progress >= 10 && progress < 20) {
            this.waitingText = 'Whilst we try and be as <strong>speedy</strong> as possible, this can take up to a few minutes...';
          } else if (progress >= 20 && progress < 40) {
            this.waitingText = 'Please <strong>do not</strong> close your browser or click "back"...';
          } else if (progress >= 40 && progress < 60) {
            this.waitingText = 'We appreciate your patience! Our <strong>average processing</strong> time today is 44 seconds...';
          } else if (progress >= 60 && progress < 80) {
            this.waitingText = 'Did you know? If you find yourself in need of future emergency cash, you can always return to speedyloans.co.uk and simply <strong>request a new loan</strong>...';
          } else if (progress >= 80 && progress < 100) {
            this.waitingText = '<strong>Almost there</strong>. Please do not close your browser or click "back"....';
          }
          if (progress !== 100) {
            setTimeout(() => {
              this.checkApplicationProgress(correlationId);
            }, 3000);
          } else if (progress === 100) {
            this.loanResult(response);
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.loanResultFail();
        });
    },
    loanResult(responseData) {
      const redirection = responseData.data.RedirectionUrl;
      if (!redirection) {
        this.loanResultFail();
      } else {
        this.loanResultSuccess(redirection);
      }
    },
    loanResultFail() {
      this.waiting = false;
      this.isCardModalActive = false;
      this.isNextModalActive = false;
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'No matching lenders found.',
      });
    },
    loanResultSuccess(redirectionUrl) {
      this.waiting = false;
      this.isCardModalActive = false;
      this.isNextModalActive = false;
      this.$swal({
        type: 'success',
        title: 'Success!',
        text: 'We have matched your loan request with your idea lender. You will now be redirected securely in a few seconds...',
        confirmButtonText: 'Go now!',
      }).then((result) => {
        if (result.value) {
          window.location = redirectionUrl;
        }
      });
      setTimeout(() => {
        window.location = redirectionUrl;
      }, 5000);
    },
  },
};
// Function for converting Date to string const dateString = date.replace('-', '');
// const year = dateString.substring(0, 4);
// const month = dateString.substring(4, 6);
// const day = dateString.substring(6, 8);
// const newDate = new Date(year, month - 1, day);
</script>


<style lang="scss">

// .carda {
//   height: 0;
// }


.select.is-fullwidth select {
  min-width: 80px;
}

.bounce-enter-active {
  animation: bounce-in .15s;
  animation-delay: .1s;
  opacity: 0;
  height: auto;
}
.bounce-leave-active {
  animation: bounce-in .15s reverse;
  margin-bottom: 200px;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.forma {
  padding: 5rem 0 3rem;
  text-align: center;
  // min-height: calc(100vh - 3.25rem);
  min-height: 535px;
  display: flex;
  align-items: center;
  justify-content: center;

  .label {
    text-align: center;
  }
}
.carda {
  width: 700px;
  margin: auto;
  max-width: calc(100% - 4rem);
}

.button {
  font-weight: 800;
}

.step-buttons-c .is-primary,
.step-buttons-c .is-success {
  margin-left: auto;
}
.step-buttons-c {
  display: flex;
  padding: 0 1.2rem;
  margin-top: 3rem;
  align-items: center;
}

.field.radio-btn.has-addons {
  justify-content: center;
}


.input, .taginput .taginput-container.is-focusable, .textarea, .select select {
  font-weight: 800;
  font-size: 1rem;
  background: #efefef;
  border: 2px solid #74ba6c;
  -webkit-box-shadow: 0px 0px 20px rgba(116, 186, 108, 0.33);
  box-shadow: 0px 0px 20px rgba(116, 186, 108, 0.33);
  border-radius: 6px;
}


.carda--8 {
  .field.radio-btn.radio-btn--blocks {
    flex-wrap: wrap;
  }
  .field.radio-btn.radio-btn--blocks .control {
    flex-basis: 50%;
    max-width: calc(50% - 0.8rem);
    margin-bottom: 0.4rem;
    margin: 0.4rem;
  }
  .field.radio-btn.radio-btn--blocks .control:nth-child(3) {
    flex-basis: 100%;
    max-width: calc(100% - 1px);
  }
  .field.radio-btn.radio-btn--blocks .control .b-radio {
    width: 100%;
    border-radius: 4px !important;
  }
}

.carda--10 {
  .has-addons button.button.is-primary {
    width: auto !important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    font-size: 0.8rem;
    height: 36px;
  }
}

.field.has-addons {
  position: relative;

  p.help.is-danger {
    position: absolute;
    top: 105%;
  }
}


.radio-btn--blocks.is-grouped.is-grouped-multiline {
  flex-wrap: wrap;
}
.field.is-grouped.is-grouped-multiline > .control {
  flex-basis: calc(50% - 0.75rem);
}
.field.is-grouped.is-grouped-multiline > .control .b-radio {
  width: 100%;
}

.carda--11 {
  .field.is-grouped.is-grouped-multiline > .control {
    max-width: calc(50% - 0.75rem);
  }
  label.b-radio.radio.button.is-large {
    height: 3em;
    white-space: normal;
  }
}

.carda.carda--23 {
  margin-top: -2rem;
}

.small {
  font-size: 0.65rem;
}

.loading-container-inner {
  background-color: #fff;
  padding: 2rem 3rem;
  width: 350px;
  max-width: 100%;
  margin: 0 1rem;
}

.loading-container .progress {
  margin: 2rem 0 1rem;
}

.swal2-popup .swal2-styled.swal2-confirm {
  background-color: #23d160;
  border-color: transparent;
  color: #fff;
  border-radius: 290486px;
  padding-left: 1em;
  padding-right: 1em;
  font-weight: 800;
  text-transform: capitalize;
  font-size: 1.5rem;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}
.no-message p.help {
  display: none !important;
}

.lc-why {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 2.6rem;
  margin-top: 1rem;
  width: calc(100% + 8rem);
  margin-left: -4rem;
  margin-right: -4rem;
}
.lc-why-icon-c .icon {
  color: #5abc62;
  border-radius: 50%;
  border: 2px solid #5abc62;
  width: 2.4rem;
  height: 2.4rem;
  margin-bottom: 0.6rem;
}
.lc-why-icon-c .icon .fas {
  font-size: 1.3rem;
  position: relative;
  top: 1px;
}
.lc-why:before {
  display: block;
  width: 390px;
  max-width: 100%;
  border-top: 1px solid #eeeeee;
  content: '';
  position: absolute;
  top: 0;
}
.lc-why-item {
  flex: 1;
  padding: 0 1rem;
}
.lc-why-content {
  font-size: 0.75rem;
}
.lc-why-content strong {
  font-size: 1rem;
  display: block;
}

// .step-buttons-c {
//   position: fixed;
//   right: 0;
//   left: 0;
//   bottom: 0;
//   padding: 0.4rem;
//   border-top: 1px solid #acddb0;
//   align-items: center;
//   justify-content: space-between;
//   background: #fff;
//   z-index: 1;
// }

@media (max-width: 768px) {
  .forma {
    display: block;
    min-height: 410px;
  }

  .carda.carda--7 {
    margin-top: -2.5rem;
  }

  .lc-why {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    padding-top: 1.6rem;
    margin-top: 0;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
  .lc-why-item {
    padding: 0;
    flex: unset;
    margin-bottom: 1rem;
  }
  .lc-why-icon-c {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lc-why-icon-c .icon {
    margin-bottom: 0;
    margin-right: 1rem;
    min-width: 2.4rem;
  }
  .carda--1 .button.is-primary {
    width: 100%;
  }
  .carda--1 .step-buttons-c {
    margin-top: 0.8rem;
    padding: 0;
  }
  .carda.carda--1 {
    margin-top: -2rem;
  }
}

@media (min-width: 769px) {
  .carda.carda--7 .media-content {
    font-size: 0.85rem;
  }
  .carda.carda--7 .media {
    align-items: center;
  }
}
</style>
